import React, { Component } from "react";
import { connect } from "react-redux";
import { changeEditerModeAction } from "../../redux/app/actions";
import { addPointAction, delPointAction, changeFieldAction, changeSelRowPAction, isDelPAction } from "../../redux/boring/actions";

const mapStateToProps = (state) => {
    return {
        regMode: state.appReducer.regMode,
        editerMode: state.appReducer.editerMode,
        ds: state.boringReducer.dataset,
        color: state.boringReducer.color,
        userData: state.boringReducer.userData,
        selRowP: state.boringReducer.selRowP,
        isDelP: state.boringReducer.isDelP,
        XCoord: state.boringReducer.XCoord,
        YCoord: state.boringReducer.YCoord,
    };
};

class User extends Component {
    /*★ここから公開版で削除*/
    constructor(props) {
        super(props);
        this.addPoint = this.addPoint.bind(this);
        this.delPoint = this.delPoint.bind(this);
        this.changeRow = this.changeRow.bind(this);
        this.changeField = this.changeField.bind(this);
        this.checkField = this.checkField.bind(this);

        this.tbRef = React.createRef();

        this.props.dispatch(changeSelRowPAction(null));
    }

    componentDidUpdate(prevProps) {
        /*
         * ポイント削除後
         * @since hara 2020-10-27
         */
        if (this.props.isDelP) {
            /*
             * ポイント名修正
             */
            const userData = [...this.props.userData];
            this.props.userData.forEach((el, index) => {
                if (this.props.selRowP <= index) {
                    userData[index] = { ...userData[index], ["userPoint"]: index };
                    window.changePointName(this.props.dsID, index + 1, index);
                }
            });
            this.props.dispatch(changeFieldAction(userData));

            /*
             * 選択行移動
             */
            const trs = this.tbRef.childNodes;
            const rowNum = trs.length;
            const selRow = this.props.selRowP;
            let newSelRow = null;

            if (selRow === rowNum) {
                //最終行削除の場合
                if (selRow !== 0) {
                    //複数行の場合前の行を選択
                    trs[rowNum - 1].click();
                    newSelRow = rowNum - 1;
                }
                this.props.dispatch(changeSelRowPAction(newSelRow));
            }

            this.props.dispatch(isDelPAction(false));
        }
    }

    /*
     * ポイント追加
     * @since hara 2020-09-30
     */
    addPoint() {
        this.props.dispatch(addPointAction(Object.keys(this.props.userData).length));
    }

    /*
     * ポイント削除
     * @since hara 2020-09-30
     */
    delPoint() {
        window.delUserPoint(this.props.dsID, this.props.selRowP);

        this.props.dispatch(delPointAction(this.props.selRowP));
        this.props.dispatch(isDelPAction(true));
    }

    /*
     * フィールド変更
     * @param {Number} index フィールドの行インデックス
     * @param {String} key フィールドの列インデックス
     * @param {Event} e イベント情報
     * @since hara 2020-10-01
     */
    changeField(index, key, e) {
        let value = e.target.value;
        if (key !== "ido_ID") value = parseFloat(value);

        const userData = [...this.props.userData];
        userData[index] = { ...userData[index], [key]: value };

        this.props.dispatch(changeFieldAction(userData));
    }

    /*
     * フィールド値チェック
     * @param {Number} index フィールドの行インデックス
     * @param {String} key フィールドの列インデックス
     * @param {Event} e イベント情報
     * @since hara 2020-10-02
     */
    checkField(index, key, e) {
        let value = e.target.value;
        if (isNaN(value)) {
            const userData = [...this.props.userData];
            userData[index][key] = 0;
            this.props.dispatch(changeFieldAction(userData));
        }
    }

    /*
     * テーブル選択
     * @param {Event} e イベント情報
     * @since hara 2020-09-30
     */
    changeRow(e) {
        e.target.closest("tbody").childNodes.forEach((el) => {
            el.classList.remove("selRow");
        });
        const tr = e.target.closest("tr");
        tr.classList.add("selRow");

        this.props.dispatch(changeSelRowPAction(parseInt(tr.id)));
    }

    render() {
        return (
            <div>
                <fieldset className="Unit">
                    <legend>ポイント</legend>
                    <div className="btnWrap">
                        <button className="sBtn" onClick={this.addPoint}>
                            追加
                        </button>
                        <button className="sBtn l-mlM" onClick={this.delPoint}>
                            削除
                        </button>
                    </div>
                    <div className="BoringUserTWrap l-mtS" style={{ overflowY: "scroll" }}>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th className="tsM">X座標</th>
                                    <th className="tsM">Y座標</th>
                                    <th>孔口標高</th>
                                    <th>地下水位</th>
                                </tr>
                            </thead>
                            <tbody ref={(ref) => (this.tbRef = ref)}>
                                {this.props.userData.map((el, index) => (
                                    <tr id={index} key={index} onClick={this.changeRow}>
                                        <td>
                                            <input className="textT" type="text" value={el.ido_ID} onChange={(e) => this.changeField(index, "ido_ID", e)} />
                                        </td>
                                        <td>
                                            <input className="textT" type="text" value={el.lon} onBlur={(e) => this.checkField(index, "lon", e)} onChange={(e) => this.changeField(index, "lon", e)} />
                                        </td>
                                        <td>
                                            <input className="textT" type="text" value={el.lat} onBlur={(e) => this.checkField(index, "lat", e)} onChange={(e) => this.changeField(index, "lat", e)} />
                                        </td>
                                        <td>
                                            <input className="textT" type="text" value={el.GL} onBlur={(e) => this.checkField(index, "GL", e)} onChange={(e) => this.changeField(index, "GL", e)} />
                                        </td>
                                        <td>
                                            <input className="textT" type="text" value={el.WL} onBlur={(e) => this.checkField(index, "WL", e)} onChange={(e) => this.changeField(index, "WL", e)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </fieldset>
            </div>
        );
    }
}

export default connect(mapStateToProps)(User);
